import { formatCreditBalance } from "../../../utils/sharedFunctions";

const SupplierDetailsCard = ({ supplier }) => {
  const currency = supplier?.currency || "USD";

  const paymentsUSD = formatCreditBalance(supplier?.payments_usd, 2);
  const paymentsLocal = formatCreditBalance(supplier?.payments_local, 2);
  const consumedUSD = formatCreditBalance(supplier?.consumed_usd, 2);
  const consumedLocal = formatCreditBalance(supplier?.consumed_local, 2);
  const currentBalance = formatCreditBalance(supplier?.balance_usd, 2);
  const currentBalanceLocal = formatCreditBalance(supplier?.balance_local, 2);
  const thresholdUSD = formatCreditBalance(supplier?.threshold_usd, 2);
  const thresholdLocal = formatCreditBalance(supplier?.threshold_local, 2);
  const criticalBalance = formatCreditBalance(supplier?.critical_balance, 2);
  const criticalBalanceUSD = formatCreditBalance(supplier?.critical_balance_usd, 2);

  return (
    <div className="row g-2">
      <div className="col-md-5 d-flex gap-2 mb-2">
        <div className="w-100">
          <div className="card">
            <div className="card-body p-2 px-4">
              <div className="d-flex align-items-center">
                <div className="card-info">
                  <small>Payments</small>
                  <h5 className="mb-0">{paymentsUSD} USD</h5>
                  <small className="mb-0 text-muted">{paymentsLocal} {currency}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-100">
          <div className="card">
            <div className="card-body p-2 px-4">
              <div className="d-flex align-items-center">
                <div className="card-info">
                  <small>Consumed</small>
                  <h5 className="mb-0">{consumedUSD} USD</h5>
                  <small className="mb-0 text-muted">{consumedLocal} {currency}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-7 mb-2">
        <div className="card">
          <div className="card-body card-body p-2 px-4">
            <div className="row g-2">
              <div className="col-md-12">
                <div className="card-info">
                  <div className="row">
                    <div className="col-2 vertical-align-middle">
                      <p className="h5 mb-0">Balance</p>
                      <div className="pt-1">
                        <i className="ti ti-coin ti-lg text-blue"></i>
                      </div>
                    </div>
                    <div className="col-10">
                      <div className="row">
                        <div className="col-4 text-end">
                          <div className="card-info border-start">
                            <small>Threshold</small>
                            <h5 className="mb-0">{thresholdUSD} USD</h5>
                            <small className="mb-0 text-muted">{thresholdLocal} {currency}</small>
                          </div>
                        </div>
                        <div className="col-4 text-end">
                          <div className="card-info">
                            <small>Critical</small>
                            <h5 className="mb-0">{criticalBalanceUSD} USD</h5>
                            <small className="mb-0 text-muted">{criticalBalance} {currency}</small>
                          </div>
                        </div>
                        <div className="col-4 text-end">
                          <div className="card-info">
                            <small>Current</small>
                            <h5 className={`mb-0 ${parseFloat(supplier?.balance_usd || 0) > 0 ? "text-success" : "text-danger"}`}>{currentBalance} USD</h5>
                            <small className="mb-0 text-muted">{currentBalanceLocal} {currency}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SupplierDetailsCard;
